module.exports = __webpack_public_path__ + "static/media/product-background.665814ca.png";